import ManagedUnmanagedComanaged from "public/privateCloud/icons/managed-unmanaged-comanaged.png";
import { SimpleList } from "@/components/list";

export const CHOOSE_ON_DEMAND_CONSTANTS = {
  title: "Choose as per your Demand",
  list: [
    {
      image: ManagedUnmanagedComanaged,
      title: "When to Choose Managed Services?",
      content: (
        <SimpleList
          points={[
            "If the organization lacks an in-house IT team.",
            "If round-the-clock monitoring, security, and compliance are needed.",
            "If outsourcing IT can reduce operational costs and downtime.",
            "If scalability and automatic updates are a priority.",
          ]}
        />
      ),
    },
    {
      image: ManagedUnmanagedComanaged,
      title: "When to Choose Unmanaged Services?",
      content: (
        <SimpleList
          points={[
            "If the business has an experienced IT team capable of handling maintenance.",
            "If full control over configurations, updates, and security is required.",
            "If cost savings on management services are more important than convenience.",
            "If the business requires a custom IT environment tailored to unique needs.",
          ]}
        />
      ),
    },
    {
      image: ManagedUnmanagedComanaged,
      title: "When to Choose Co-managed Services?",
      content: (
        <SimpleList
          points={[
            "If an existing IT team needs external support without full outsourcing.",
            "If the business needs expertise in cybersecurity, compliance, or cloud management.",
            "If the organization wants cost-effective IT management without losing control.",
            "If additional staff augmentation or workload sharing is required.",
          ]}
        />
      ),
    },
  ],
};
